import { z } from 'zod';

import { currencySchema } from '../currency';
import { membershipRoleSchema } from '../membership';
import { ulidSchema } from '../primitives';
import { restaurantStatusSchema } from '../restaurant';
import { savedUserAddressSelfSchema } from '../user';

export {
  patchMeRequestSchema,
  postSavedAddressRequestSchema,
  patchSavedAddressRequestSchema,
  savedAddressPathParamsSchema,
} from '../user';
export type {
  PatchMeRequest,
  PostSavedAddressRequest,
  PatchSavedAddressRequest,
  SavedAddressPathParams,
} from '../user';

export const meAddressesListResponseSchema = z.object({
  addresses: z.array(savedUserAddressSelfSchema),
});
export type MeAddressesListResponse = z.infer<typeof meAddressesListResponseSchema>;

/** Placeholder body until Cognito admin-create-user + order linking is wired. */
export const postMeUpgradeRequestSchema = z.object({
  upgradeToken: z.string().min(1).max(4096),
});
export type PostMeUpgradeRequest = z.infer<typeof postMeUpgradeRequestSchema>;

export const postMeUpgradeResponseSchema = z.object({
  status: z.literal('NOT_IMPLEMENTED'),
  message: z.string(),
});
export type PostMeUpgradeResponse = z.infer<typeof postMeUpgradeResponseSchema>;

export const meRestaurantMembershipSchema = z.object({
  restaurantId: ulidSchema,
  name: z.string(),
  status: restaurantStatusSchema,
  role: membershipRoleSchema,
});
export type MeRestaurantMembership = z.infer<typeof meRestaurantMembershipSchema>;

export const meRestaurantsResponseSchema = z.object({
  items: z.array(meRestaurantMembershipSchema),
});
export type MeRestaurantsResponse = z.infer<typeof meRestaurantsResponseSchema>;

export const meStatsTopMenuItemSchema = z.object({
  name: z.string(),
  revenueMinorUnits: z.string(),
  orderCount: z.number().int(),
});
export type MeStatsTopMenuItem = z.infer<typeof meStatsTopMenuItemSchema>;

export const meStatsRestaurantStatSchema = z.object({
  restaurantId: ulidSchema,
  revenueMtdMinorUnits: z.string(),
  revenueLastMonthMinorUnits: z.string(),
  pendingOrderCount: z.number().int(),
  nextPayoutAmountMinorUnits: z.string().nullable(),
});
export type MeStatsRestaurantStat = z.infer<typeof meStatsRestaurantStatSchema>;

export const meStatsResponseSchema = z.object({
  currency: currencySchema,
  revenueMtdMinorUnits: z.string(),
  revenueLastMonthMinorUnits: z.string(),
  pendingOrderCount: z.number().int(),
  activeOrderCount: z.number().int(),
  topMenuItems: z.array(meStatsTopMenuItemSchema),
  restaurantStats: z.array(meStatsRestaurantStatSchema),
});
export type MeStatsResponse = z.infer<typeof meStatsResponseSchema>;
